/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - AVERAGE IN VIEW REPORT : STYLES --------------- ++++++++++ */
export default {
    avginviewreport: {
    }
};
